import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image } from 'react-bootstrap';
import PhotosModal from './PhotosModal';

function hasPhotos(photos) {
  if (!photos) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(photos, 'length')) {
    return photos.length !== 0;
  }
  return false;
}

function formatPhotos(photos, modalMethod) {
  if (hasPhotos(photos)) {
    const photoList = [];
    photos.forEach(photo => {
      if (photo.photo) {
        photoList.push(
          <div className="col-md-3" key={photo.id}>
            <a onClick={() => modalMethod(photos.indexOf(photo))} className="hotel-photo-link">
              <div className="hotel-photo-underlay hotel-photo">
                <Image src={photo.photo} responsive className="hotel-img" />
                <i className="fa fa-search-plus hotel-photo-overlay" />
              </div>
            </a>
          </div>
        );
      } else {
        photoList.push(
          <div key={photo.id} className="col-sm-3 col-md-3">
            <div className="caption">
              <h4>Error missing URL for photo {photo.name}</h4>
            </div>
          </div>
        );
      }
    });
    return photoList;
  }
  return (
    <div className="col-md-12">
      <h4 className="hotel-highlight">No photos available</h4>
    </div>
  );
}

class PhotosView extends React.Component {
  openModal = indx => {
    this.modal.handleShow(indx);
  };
  render() {
    const modalPhotos = this.props.hotel.photos;
    const photos = formatPhotos(this.props.hotel.photos, this.openModal);
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h1 className="hotel-detail-subhead">
              Photos <Button onClick={this.props.handleEdit}>Edit</Button>
            </h1>
          </div>
        </div>
        <div className="row">{photos}</div>
        <PhotosModal
          ref={node => {
            this.modal = node;
          }}
          photos={modalPhotos}
        />
      </div>
    );
  }
}
PhotosView.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};
PhotosView.defaultTypes = {
  photos: [],
};
export default PhotosView;


// WEBPACK FOOTER //
// src/routes/hotels/components/PhotosView.js